import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import SamplePage from "@/pages/SamplePage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SamplePage />} />
          <Route path="/full" element={<LandingPage />} />
          <Route path="/sample" element={<SamplePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        richColors
        toastOptions={{
          style: {
            background: "#0f0f10",
            border: "1px solid rgba(249, 115, 22, 0.35)",
            color: "#fff",
          },
        }}
      />
    </div>
  );
}

export default App;
